import React from 'react';

function MentionSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12.058 3.37599L12.3359 3.37898C15.8534 3.48634 18.9591 5.74538 20.1369 9.08447C21.3455 12.5112 20.2601 16.3284 17.4296 18.6047C14.7562 20.7547 11.0766 21.0873 8.07842 19.5004L7.85499 19.377L3.26897 21.5641C2.76721 21.8034 2.24434 21.3221 2.40079 20.8202L2.43559 20.7315L4.61899 16.139L4.48934 15.9016C3.20071 13.4514 3.17628 10.5176 4.43899 8.03975L4.58459 7.76635C6.09367 5.05188 8.95552 3.37053 12.058 3.37599ZM10.75 12.0003C10.75 11.31 11.3095 10.75 12 10.75C12.6905 10.75 13.25 11.31 13.25 12.0003C13.25 12.6907 12.6905 13.2507 12 13.2507C11.3095 13.2507 10.75 12.6907 10.75 12.0003ZM7.99999 10.75C7.30946 10.75 6.74999 11.31 6.74999 12.0003C6.74999 12.6907 7.30946 13.2507 7.99999 13.2507C8.69052 13.2507 9.24999 12.6907 9.24999 12.0003C9.24999 11.31 8.69052 10.75 7.99999 10.75ZM14.75 12.0003C14.75 11.31 15.3095 10.75 16 10.75C16.6905 10.75 17.25 11.31 17.25 12.0003C17.25 12.6907 16.6905 13.2507 16 13.2507C15.3095 13.2507 14.75 12.6907 14.75 12.0003Z"
        fillRule="evenodd"
      />
    </svg>
  );
}
export default MentionSolid;
